import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BaseCoreState, baseAdministrationActions, baseAdministrationSelectors } from 'base';

@Injectable({ providedIn: 'root' })
export class BaseCustomerLocationsGuard {
  constructor(private store: Store<BaseCoreState>) {}

  canActivate(): Observable<boolean> {
    this.store.dispatch(baseAdministrationActions.loadLocations({ payload: {} }));

    return this.store.select(baseAdministrationSelectors.getLocations).pipe(
      filter((state) => !!state.ok),
      map((state) => state.ok as boolean)
    );
  }
}
